import { styled } from 'styled-components';

export const CornerBoxInput = ({
  point,
  setPoint,
}: {
  point: 'TopLeft' | 'TopRight' | 'BottomLeft' | 'BottomRight' | 'All';
  setPoint: (
    point: 'TopLeft' | 'TopRight' | 'BottomLeft' | 'BottomRight' | 'All'
  ) => void;
}) => {
  return (
    <Container>
      <Box>
        {point !== 'All' && <Circle onClick={() => setPoint('All')} />}
        {point === 'All' && <span key="All">All</span>}

        <Circle
          $active={point === 'All' || point === 'TopLeft'}
          $topLeft
          onClick={() => setPoint('TopLeft')}
        />
        <Circle
          $active={point === 'All' || point === 'TopRight'}
          $topRight
          onClick={() => setPoint('TopRight')}
        />
        <Circle
          $active={point === 'All' || point === 'BottomLeft'}
          $bottomLeft
          onClick={() => setPoint('BottomLeft')}
        />
        <Circle
          $active={point === 'All' || point === 'BottomRight'}
          $bottomRight
          onClick={() => setPoint('BottomRight')}
        />
      </Box>
    </Container>
  );
};

const Container = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
  border: 1px solid var(--input-border-color);

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-weight: 300;
  color: var(--accent-color);
`;

const Circle = styled.div<{
  $active?: boolean;
  $topLeft?: boolean;
  $topRight?: boolean;
  $bottomLeft?: boolean;
  $bottomRight?: boolean;
}>`
  position: absolute;
  width: 20px;
  height: 20px;

  border: 1px solid var(--input-border-color);
  border-radius: 50%;
  background-color: var(--panel-bg-color);

  transition:
    border 0.3s ease,
    background-color 0.3s ease;

  &:hover {
    border: 1px solid var(--text-color);
    background-color: var(--panel-bg-color-hover);
  }

  ${({ $active }) => $active && `border-color: var(--accent-color);`}

  ${({ $topLeft }) =>
    $topLeft && `top: 0; left: 0; transform: translate(-50%, -50%);`}

  ${({ $topRight }) =>
    $topRight && `top: 0; right: 0; transform: translate(50%, -50%);`}

  ${({ $bottomLeft }) =>
    $bottomLeft && `bottom: 0; left: 0; transform: translate(-50%, 50%);`}

  ${({ $bottomRight }) =>
    $bottomRight && `bottom: 0; right: 0; transform: translate(50%, 50%);`}
`;
